import {
  pgTable,
  uuid,
  text,
  integer,
  timestamp,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const pushSubscriptions = pgTable(
  "push_subscriptions",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    userId: text("user_id").notNull(),
    endpoint: text("endpoint").notNull(),
    p256dh: text("p256dh").notNull(),
    auth: text("auth").notNull(),
    expirationTime: timestamp("expiration_time", tz),
    userAgent: text("user_agent"),
    lastSentAt: timestamp("last_sent_at", tz),
    lastErrorAt: timestamp("last_error_at", tz),
    lastErrorMessage: text("last_error_message"),
    failureCount: integer("failure_count").notNull().default(0),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_push_subscriptions_tenant_user").on(table.tenantId, table.userId),
    uniqueIndex("uq_push_subscriptions_tenant_endpoint").on(table.tenantId, table.endpoint),
  ],
);
